import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../directory/Directory.css";
import Select from 'react-select/async';

const Directory = () => {
  const [editingType, setEditingType] = useState(null);
  const [editingName, setEditingName] = useState(null);
  const [editingPackage, setEditingPackage] = useState(null);
  const [newName, setNewName] = useState('');
  const [contractors, setContractors] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [contractorRestaurants, setContractorRestaurants] = useState([]);
  const [expandedRestaurantId, setExpandedRestaurantId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [contractorType, setContractorType] = useState(null);
  const [contractorUsers, setContractorUsers] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [contractorEmails, setContractorEmails] = useState([]);
  const [showAddEmail, setShowAddEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [editingGroupName, setEditingGroupName] = useState(null);
  const [newGroupName, setNewGroupName] = useState('');
  const [selectedSource, setSelectedSource] = useState('');
  const [source, setSource] = useState('');
  const [sourceLoaded, setSourceLoaded] = useState(false);
  const [commissionCfg, setCommissionCfg] = useState(null);
  
  const [fopData, setFopData] = useState({
    name_fop: '',
    contractor_id: '',
    rest_id: '',
    edrpou: '',
    user_id_ch: localStorage.getItem('userId')
  });
  const [commissionConfig, setCommissionConfig] = useState(null);
  const [userRegions, setUserRegions] = useState({});
  const [contractorRegion, setContractorRegion] = useState({ region: 'uk-UA' });

  // Додайте новий параметр для регіонів
  const regionOptions = [
    { label: 'Україна', value: 'uk-UA' },
    { label: 'Польща', value: 'pl-PL' },
    { label: 'Чеська', value: 'cs-CZ' }
  ];

  const sourceOptions = ['Dao', 'IT Gurman', 'RSC',  'Інші'];

  const accessRightsLabels = {
    '1': 'Обмеження',
    '2': 'Зняття обмеження'
  };

  const regionLabels = {
    'uk-UA': 'Українська',
    'pl-PL': 'Польська',
    'cs-CZ': 'Чеська'
  };

  const pacOptions = {
    solo: [
      { label: 'BASIC', value: 'BASIC', limit: 3 },
      { label: 'START', value: 'START', limit: 10 },
      { label: 'PRO', value: 'PRO', limit: 20 },
      { label: 'EXCLUSIVE', value: 'EXCLUSIVE', limit: 50 }
    ],
    chain: [
      { label: 'BASIC', value: 'BASIC', limit: 3 },
      { label: 'START', value: 'START', limit: 10 },
      { label: 'PRO', value: 'PRO', limit: 20 },
      { label: 'EXCLUSIVE', value: 'EXCLUSIVE', limit: 50 }
    ]
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://bank2.daolog.net/contractors-with-users-and-restaurants');
        const fopCountResponse = await axios.get('https://bank2.daolog.net/contractors-with-fop-count');
        const fopCountAmResponse = await axios.get('https://bank2.daolog.net/contractors-with-fop-count-am');
        
        const contractorsWithFopCount = response.data.map(contractor => {
          const fopCountData = fopCountResponse.data.find(fc => fc.id === contractor.id);
          const fopCountAmData = fopCountAmResponse.data.find(fc => fc.id === contractor.id);
          return {
            ...contractor,
            current_fop_count: fopCountData ? fopCountData.current_fop_count : 0,
            current_fop_count_am: fopCountAmData ? fopCountAmData.current_fop_count : 0,
            fop_amount: fopCountData ? fopCountData.fop_amount : 0,
            pac: contractor.pac || 'BASIC'
          };
        });
        
        setContractors(contractorsWithFopCount);
  
        if (expandedId) {
          const [sourceResponse, configResponse, usersResponse, regionResponse] = await Promise.all([
            axios.get(`https://bank2.daolog.net/contractor-source/${expandedId}`),
            axios.get(`https://bank2.daolog.net/contractor-config/${expandedId}`),
            axios.get(`https://bank2.daolog.net/contractor-users/${expandedId}`),
            axios.get(`https://bank2.daolog.net/contractor-region/${expandedId}`)
          ]);
          setSource(sourceResponse.data.source || '');
          setCommissionConfig(configResponse.data);
          setContractorRegion(regionResponse.data);
          setSourceLoaded(true);
          
          // Store user regions in state
          const userRegionsMap = {};
          usersResponse.data.forEach(user => {
            userRegionsMap[user.id] = user.region;
          });
          setUserRegions(userRegionsMap);
        }
      } catch (error) {
        console.error('Помилка отримання даних:', error);
      }
    };
    fetchData();
  }, [expandedId]);
  
  // Додайте ще один useEffect для отримання даних про регіон
  useEffect(() => {
    if (expandedId) {
      const fetchContractorData = async () => {
        try {
          const [sourceResponse, configResponse, usersResponse, regionResponse] = await Promise.all([
            axios.get(`https://bank2.daolog.net/contractor-source/${expandedId}`),
            axios.get(`https://bank2.daolog.net/contractor-config/${expandedId}`),
            axios.get(`https://bank2.daolog.net/contractor-users/${expandedId}`),
            axios.get(`https://bank2.daolog.net/contractor-region/${expandedId}`)
          ]);
          setSource(sourceResponse.data.source || '');
          setCommissionCfg(configResponse.data);
          setContractorRegion(regionResponse.data);
          setSourceLoaded(true);
        } catch (error) {
          console.error('Помилка отримання даних контрактора:', error);
        }
      };
      fetchContractorData();
    }
  }, [expandedId]);

  const handleRegionConfigChange = async (newRegion) => {
    try {
      const response = await axios.put(`https://bank2.daolog.net/contractor-region/${expandedId}`, {
        region: newRegion
      });
      setContractorRegion({ ...contractorRegion, region: newRegion });
    } catch (error) {
      console.error('Помилка оновлення регіону:', error);
    }
  };
  
  // Add this handler function
  const handleCommissionStatusChange = async (newStatus) => {
    try {
      const response = await axios.post(`https://bank2.daolog.net/api/update-rights-config`, {
        contractorId: expandedId,
        config: { status: newStatus }
      });
      setCommissionCfg({ ...commissionCfg, status: newStatus });
    } catch (error) {
      console.error('Помилка оновлення конфігу:', error);
    }
  };

  const handleRegionChange = async (userId, newRegion) => {
    try {
      await axios.put(`https://bank2.daolog.net/update-user-region/${userId}`, {
        region: newRegion
      });
      
      // Update both contractorUsers and userRegions states
      setContractorUsers(prevUsers => 
        prevUsers.map(user => {
          if (user.id === userId) {
            return {
              ...user,
              region: newRegion
            };
          }
          return user;
        })
      );
      
      setUserRegions(prev => ({
        ...prev,
        [userId]: newRegion
      }));
      
    } catch (error) {
      console.error('Error updating region:', error);
      alert('Помилка при оновленні країни');
    }
  };
  

  


  const handleCommissionChange = async (newStatus) => {
    try {
      const response = await axios.put(`https://bank2.daolog.net/contractor-config/${expandedId}`, {
        status: newStatus
      });
      setCommissionConfig({ ...commissionConfig, status: newStatus });
    } catch (error) {
      console.error('Помилка оновлення конфігу:', error);
    }
  };

  

  const handleNameEdit = (contractor) => {
    setEditingName(contractor.id);
    setNewName(contractor.name);
  };

  const handleGroupNameEdit = (contractor) => {
    setEditingGroupName(contractor.id);
    setNewGroupName(contractor.group_name || '');
  };

  const handleSourceChange = async (value) => {
    setSource(value); 
    try {
      await axios.put('https://bank2.daolog.net/update-contractor-source', {
        contractorId: expandedId,
        source: value
      });
      
    } catch (error) {
      console.error('Помилка оновлення джерела:', error);
      setSource(source); 
    }
  };
  
  const handleGroupNameSave = async (contractorId) => {
    try {
      const response = await axios.put(`https://bank2.daolog.net/contractor-group-name/${contractorId}`, {
        group_name: newGroupName
      });
      
      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            return {
              ...contractor,
              group_name: response.data.group_name
            };
          }
          return contractor;
        })
      );
      
      setEditingGroupName(null);
      setNewGroupName('');
    } catch (err) {
      console.error('Error updating group name:', err);
    }
  };

  const handleAccessRightsChange = async (userId, newAccessRights) => {
    try {
      await axios.put(`https://bank2.daolog.net/update-user-access/${userId}`, {
        access_rights: newAccessRights
      });
      
      setContractorUsers(prevUsers => 
        prevUsers.map(user => {
          if (user.id === userId) {
            return {
              ...user,
              access_rights: newAccessRights
            };
          }
          return user;
        })
      );
    } catch (error) {
      console.error('Error updating access rights:', error);
      alert('Помилка при оновленні прав доступу');
    }
  };

  const handleAddEmail = async (contractorId) => {
    try {
      const response = await axios.post('https://bank2.daolog.net/add-contractor-email', {
        contractorId,
        email: newEmail
      });
      
      setContractorEmails([...contractorEmails, { email: newEmail }]);
      setNewEmail('');
      setShowAddEmail(false);
    } catch (error) {
      console.error('Error adding email:', error);
      alert('Помилка при додаванні email');
    }
  };

  const handlePackageChange = async (contractorId, newPac) => {
    try {
      const selectedOption = [...pacOptions.solo, ...pacOptions.chain].find(option => option.value === newPac);
      if (!selectedOption) {
        throw new Error('Invalid PAC option');
      }

      await axios.put(`https://bank2.daolog.net/update-contractor-package/${contractorId}`, {
        fop_amount: selectedOption.limit,
        pac: selectedOption.value
      });

      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            return {
              ...contractor,
              fop_amount: selectedOption.limit,
              pac: selectedOption.value
            };
          }
          return contractor;
        })
      );
      
      setEditingPackage(null);
    } catch (error) {
      console.error('Error updating package:', error);
      alert('Помилка при оновленні пакету: ' + error.message);
    }
  };

  const handleNameSave = async (contractorId) => {
    try {
      await axios.put(`https://bank2.daolog.net/contractor-name/${contractorId}`, {
        name: newName
      });
      
      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            return {
              ...contractor,
              name: newName
            };
          }
          return contractor;
        })
      );
      
      setEditingName(null);
      setNewName('');
    } catch (err) {
      console.error('Error updating contractor name:', err);
    }
  };

  const handleTypeChange = async (contractorId, newType) => {
    try {
      const response = await axios.put(`https://bank2.daolog.net/contractor-type/${contractorId}`, {
        type: newType ? 'chain' : 'solo'
      });
      
      setContractorType(newType ? 'chain' : 'solo');
      setEditingType(null);
      
      // Update contractors with default package when switching type
      setContractors(prevContractors => 
        prevContractors.map(contractor => {
          if (contractor.id === contractorId) {
            const defaultPac = 'BASIC';
            const defaultLimit = (newType ? pacOptions.chain : pacOptions.solo)
              .find(opt => opt.value === defaultPac)?.limit || 3;
            
            return {
              ...contractor,
              type: newType ? 'chain' : 'solo',
              fop_amount: defaultLimit,
              pac: defaultPac
            };
          }
          return contractor;
        })
      );
      
    } catch (err) {
      console.error('Error updating contractor type:', err);
    }
  };

  const handleContractorClick = async (contractor) => {
    if (expandedId === contractor.id) {
      setExpandedId(null);
      setExpandedRestaurantId(null);
      setContractorType(null);
      setContractorUsers([]);
      setContractorEmails([]);
      setSourceLoaded(false);
      setContractorRegion({ region: 'uk-UA' }); // Reset region
    } else {
      setExpandedId(contractor.id);
      setExpandedRestaurantId(null);
      try {
        const [restaurantsResponse, typeResponse, usersResponse, emailsResponse, sourceResponse, regionResponse] = await Promise.all([
          axios.get(`https://bank2.daolog.net/contractor-restaurants-with-fops/${contractor.id}`),
          axios.get(`https://bank2.daolog.net/contractor-type/${contractor.id}`),
          axios.get(`https://bank2.daolog.net/contractor-users/${contractor.id}`),
          axios.get(`https://bank2.daolog.net/contractor-emails/${contractor.id}`),
          axios.get(`https://bank2.daolog.net/contractor-source/${contractor.id}`),
          axios.get(`https://bank2.daolog.net/contractor-region/${contractor.id}`)
        ]);
        setContractorRestaurants(restaurantsResponse.data);
        setContractorType(typeResponse.data.type);
        setContractorUsers(usersResponse.data);
        setContractorEmails(emailsResponse.data);
        setSource(sourceResponse.data.source || '');
        setContractorRegion(regionResponse.data);
        setSourceLoaded(true);
      } catch (err) {
        console.error('Error fetching contractor data:', err);
      }
    }
  };

  const handleRestaurantClick = (restaurantId) => {
    if (expandedRestaurantId === restaurantId) {
      setExpandedRestaurantId(null);
    } else {
      setExpandedRestaurantId(restaurantId);
    }
  };

  const getSubscriptionType = (fopAmount, isChain) => {
    const options = isChain ? pacOptions.chain : pacOptions.solo;
    const option = options.find(opt => opt.limit === fopAmount) || options[0]; // Use first option as default
    return `${option.value} (до ${option.limit}х контрагентів одночасно)`;
  };

  const filteredContractors = contractors.filter(contractor =>
    contractor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', marginTop: "120px" }}>
    <h1 style={{ color: '#333', borderBottom: '2px solid #333', paddingBottom: '10px' }}>Довідник</h1>
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <input
        type="text"
        placeholder="Пошук клієнта..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          padding: '10px',
          width: '300px',
          borderRadius: '5px',
          border: '1px solid #ddd',
          fontSize: '16px'
        }}
      />
    </div>
    {filteredContractors.map((contractor) => (
        <div key={contractor.id} className="contractor-container">
          <div 
            className="contractor-header"
            onClick={() => handleContractorClick(contractor)}
            style={{ textAlign: 'center', position: 'relative' }}
          >
            {editingName === contractor.id ? (
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }} onClick={(e) => e.stopPropagation()}>
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  style={{ padding: '2px' }}
                />
                <button
                  onClick={() => handleNameSave(contractor.id)}
                  style={{
                    padding: '2px 8px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    marginRight: '5px'
                  }}
                >
                  Зберегти
                </button>
                <button
                  onClick={() => {
                    setEditingName(null);
                    setNewName('');
                  }}
                  style={{
                    padding: '2px 8px',
                    fontSize: '12px',
                    cursor: 'pointer'
                  }}
                >
                  Скасувати
                </button>
              </div>
            ) : (
              <>
                <span>{contractor.name}</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNameEdit(contractor);
                  }}
                  style={{
                    position: 'absolute',
                    right: '20px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    cursor: 'pointer'
                  }}
                >
                  Змінити
                </button>
              </>
            )}
          </div>
          
          {expandedId === contractor.id && (
            <div className="contractor-details">
              <div className="info-section">
                <h3>Інформація про клієнтів</h3>
                <p style={{ marginBottom: '15px' }}>
                <strong> Кількість контрагентів: </strong>(Створено {contractor.current_fop_count} з {contractor.fop_amount})
                </p>
                <p style={{ marginBottom: '15px' }}>
                <strong>Кількість контрагентів без деактивованих: </strong>(Створено {contractor.current_fop_count_am} з {contractor.fop_amount})
              </p>
                
                <p><strong>Назва:</strong> {contractor.name}</p>
               
                <p>
                 

                <div>
                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
  <strong>Звідки лід: </strong>
  
  <select
    value={sourceLoaded ? source : ''}
    onChange={(e) => handleSourceChange(e.target.value)}
    style={{ marginLeft: '10px', padding: '2px' }}
  >
    <option value="">Не вказано</option>
    {sourceOptions.map(option => (
      <option key={option} value={option}>
        {option}
      </option>
    ))}
  </select>
  <p style={{ marginBottom: '15px' }}>
        <strong>Регіон для списку банків і сторінки контрагентів: </strong> 
        <select 
          value={contractorRegion.region} 
          onChange={(e) => handleRegionConfigChange(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {regionOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </p>
</div>
      </div>

  <strong >Телеграм група:</strong> {editingGroupName === contractor.id ? (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }} onClick={(e) => e.stopPropagation()}>
      <input
        type="text"
        value={newGroupName}
        onChange={(e) => setNewGroupName(e.target.value)}
        style={{ padding: '2px' }}
      />
      <button
        onClick={() => handleGroupNameSave(contractor.id)}
        style={{
          padding: '2px 8px',
          fontSize: '12px',
          cursor: 'pointer',
          marginRight: '5px'
        }}
      >
        Зберегти
      </button>
      <button
        onClick={() => {
          setEditingGroupName(null);
          setNewGroupName('');
        }}
        style={{
          padding: '2px 8px',
          fontSize: '12px',
          cursor: 'pointer'
        }}
      >
        Скасувати
      </button>
    </div>
  ) : (
    <>
      <span>{contractor.group_name || 'Не вказано'}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleGroupNameEdit(contractor);
        }}
        style={{
          marginLeft: '10px',
          padding: '2px 8px',
          fontSize: '12px',
          cursor: 'pointer'
        }}
      >
        Змінити
      </button>
    </>
  )}
</p>

                <p>
      <strong>Email для рахунків:</strong> {contractorEmails.map(email => email.email).join(', ')}
      <button
        onClick={() => setShowAddEmail(true)}
        style={{
          marginLeft: '10px',
          padding: '2px 8px',
          fontSize: '12px',
          cursor: 'pointer'
        }}
      >
        +
      </button>
    </p>
    {showAddEmail && (
      <div style={{ marginTop: '10px', marginBottom: '10px' }}>
        <input
          type="email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          placeholder="Введіть email"
          style={{
            padding: '5px',
            marginRight: '10px'
          }}
        />
        <button
          onClick={() => handleAddEmail(expandedId)}
          style={{
            padding: '5px 10px',
            marginRight: '5px',
            cursor: 'pointer'
          }}
        >
          Додати
        </button>
        <button
          onClick={() => {
            setShowAddEmail(false);
            setNewEmail('');
          }}
          style={{
            padding: '5px 10px',
            cursor: 'pointer'
          }}
        >
          Скасувати
        </button>
      </div>
    )}

                <p>
                  <strong>Мережевий:</strong> {editingType === contractor.id ? (
                    <select 
                      value={contractorType === 'chain'}
                      onChange={(e) => handleTypeChange(contractor.id, e.target.value === 'true')}
                      style={{ marginLeft: '10px', padding: '2px' }}
                    >
                      <option value="true">Так</option>
                      <option value="false">Ні</option>
                    </select>
                  ) : (
                    <>
                      {contractorType === 'chain' ? 'Так' : 'Ні'}
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingType(contractor.id);
                        }}
                        style={{
                          marginLeft: '10px',
                          padding: '2px 8px',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        Змінити
                      </button>
                    </>
                  )}
                </p>
                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
  <strong>Права доступу: </strong>
  <span style={{ marginLeft: '5px' }}>
    {commissionCfg?.status === "2" ? "Зняття обмеження" : "Обмеження"}
  </span>
  <select
    value={commissionCfg?.status || '1'}
    onChange={(e) => handleCommissionStatusChange(e.target.value)}
    style={{ marginLeft: '10px', padding: '2px' }}
  >
    <option value="1">{accessRightsLabels['1']}</option>
    <option value="2">{accessRightsLabels['2']}</option>
  </select>
</div>
                <p>
                  
                <strong>Пакет:</strong> {editingPackage === contractor.id ? (
                    <select
                      value={contractor.pac}
                      onChange={(e) => handlePackageChange(contractor.id, e.target.value)}
                      style={{ marginLeft: '10px', padding: '2px' }}
                    >
                      {(contractorType === 'chain' ? pacOptions.chain : pacOptions.solo).map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <>
                      {getSubscriptionType(contractor.fop_amount, contractorType === 'chain')}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingPackage(contractor.id);
                        }}
                        style={{
                          marginLeft: '10px',
                          padding: '2px 8px',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        Змінити
                      </button>
          </>
        )}
      </p>
      
                <p><strong>Користувачі:</strong> {contractorUsers.map(user => user.username).join(', ')}</p>
                <p>
  <strong>Вирахунок комісії:</strong>
  <select
    value={commissionConfig?.status || "1"}
    onChange={(e) => handleCommissionChange(e.target.value)}
    style={{ marginLeft: '10px', padding: '2px' }}
  >
    <option value="1">100+3</option>
    <option value="2">97+3</option>
  </select>
</p>


                <p>
      <strong>Користувачі та їх права:</strong>
      {contractorUsers.map(user => (
        <div key={user.id} style={{ marginLeft: '20px', marginTop: '10px' }}>
          <span>{user.username} </span>
        
        </div>
      ))}
    </p>
    
    <p>
                  <strong>Мова користувача:</strong>
                  {contractorUsers.map(user => (
                    <div key={user.id} style={{ marginLeft: '20px', marginTop: '10px' }}>
                      <span>{user.username} - Мова користувача: {regionLabels[user.region]}</span>
                      <select
                        value={user.region}
                        onChange={(e) => handleRegionChange(user.id, e.target.value)}
                        style={{ marginLeft: '10px', padding: '2px' }}
                      >
                        <option value="uk-UA">Українська</option>
                        <option value="pl-PL">Польська</option>
                        <option value="cs-CZ">Чеська</option>
                      </select>
                    </div>
                  ))}
                </p>

                
              </div>

              <div className="restaurants-section">
                <h3>Ресторани:</h3>
                <ul>
                  {contractorRestaurants.map((restaurant) => (
                    <li key={restaurant.id}>
                      <div 
                        className="restaurant-name"
                        onClick={() => handleRestaurantClick(restaurant.id)}
                        style={{ textAlign: 'center', position: 'relative' }}
                      >
                        {restaurant.name} (UID: {restaurant.uid})
                      </div>
                      {expandedRestaurantId === restaurant.id && restaurant.fops.length > 0 && (
                        <div className="restaurant-fops">
                           <div style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  gap: '5px',
                                  fontSize: '24px'
                                }}>
                          <p>Контрагенти ресторану:</p></div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {restaurant.fops.map((fop) => (
                              <div 
                                key={fop.id}
                                style={{
                                  border: '1px solid #ddd',
                                  borderRadius: '5px',
                                  padding: '10px',
                                  flex: '1 1 300px',
                                  maxWidth: '100%',
                                  textAlign: 'center'
                                }}
                              >
                                <div style={{ 
                                  fontWeight: 'bold', 
                                  marginBottom: '5px',
                                  wordBreak: 'break-word'
                                }}>
                                  {fop.name_fop}
                                </div>
                                <div style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  gap: '5px',
                                  fontSize: '14px'
                                }}>
                                  {fop.created_username && (
                                    <span>
                                      Активував: {fop.created_username}
                                    </span>
                                  )}
                                  <span>
                                    (Активовано: {new Date(fop.created_at).toLocaleDateString()})
                                  </span>
                                  {fop.del_date && (
                                    <>
                                      {fop.deactivated_username && (
                                        <span>
                                          Деактивував: {fop.deactivated_username}
                                        </span>
                                      )}
                                      <span>
                                        (Деактивовано: {new Date(fop.del_date).toLocaleDateString()})
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Directory;

